import { render, staticRenderFns } from "./DressListing.vue?vue&type=template&id=7de1237f&scoped=true"
import script from "./DressListing.vue?vue&type=script&lang=js"
export * from "./DressListing.vue?vue&type=script&lang=js"
import style0 from "./DressListing.vue?vue&type=style&index=0&id=7de1237f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de1237f",
  null
  
)

export default component.exports